import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

const DOWNLOAD_LINKS = [
  { id: 'google-play', href: '#', label: 'Google Play', src: '/downloads/google-play.png' },
  { id: 'app-store', href: '#', label: 'App Store', src: '/downloads/app-store-trim.png' },
  { id: 'windows', href: '#', label: 'Windows Store', src: '/downloads/windows-store.png' },
] as const

function preventPlaceholderNav(e: React.MouseEvent<HTMLAnchorElement>) {
  e.preventDefault()
}

// TODO: real store URLs once the apps are published; until then the badges stay muted and inert.
export function AppDownloadBadges({ className }: { className?: string }) {
  const { t } = useTranslation()
  return (
    <div className={cn('prod-store-badges', className)}>
      {DOWNLOAD_LINKS.map((item) => (
        <a
          key={item.id}
          href={item.href}
          className="prod-store-badges__link"
          aria-label={`${item.label}, ${t('common.comingSoon')}`}
          aria-disabled="true"
          onClick={preventPlaceholderNav}
        >
          <img src={item.src} alt="" className="prod-store-badges__logo" />
        </a>
      ))}
    </div>
  )
}
